import { Cell, Grid, Theme, VFlow } from 'bold-ui'
import { useScrollPosition } from 'bold-ui/lib/hooks'
import { useCabecalhoMinimizado } from 'hooks/useCabecalhoMinimizado'
import React, { CSSProperties, useMemo } from 'react'
import { useLocalStyles } from 'view/atendimentos/atendimento-individual/AtendimentoIndividualView'

import { ProblemaCondicaoModel } from '../avaliacao/components/problemas-condicoes/model'
import { CondicoesAutorreferidasSection } from './condicoes-autorreferidas/CondicoesAutorreferidasSection'
import { ProblemasSection } from './lista-problemas/ProblemasSection'
import { MedicamentosSection } from './medicamentos/MedicamentosSection'
import { MedicoesSection } from './medicoes/MedicoesSection'

interface AsideViewProps {
  prontuarioId: ID
  dataAtendimento: Instant
  cidadaoId: ID
  problemasAvaliados?: ProblemaCondicaoModel[]
}

export const AsideView = (props: AsideViewProps) => {
  const { prontuarioId, dataAtendimento, cidadaoId, problemasAvaliados } = props
  const { scrollY } = useScrollPosition()
  const isCabecalhoMinimizado = useCabecalhoMinimizado()
  const { classes } = useLocalStyles(createStyles, isCabecalhoMinimizado, scrollY)

  const renderSections = useMemo(() => {
    return (
      <VFlow>
        <Grid>
          <Cell size={12}>
            <ProblemasSection prontuarioId={prontuarioId} problemasAvaliados={problemasAvaliados ?? []} />
            <MedicoesSection prontuarioId={prontuarioId} dataAtendimento={dataAtendimento} />
            <MedicamentosSection prontuarioId={prontuarioId} dataAtendimento={dataAtendimento} />
            <CondicoesAutorreferidasSection cidadaoId={cidadaoId} />
          </Cell>
        </Grid>
      </VFlow>
    )
  }, [cidadaoId, dataAtendimento, problemasAvaliados, prontuarioId])

  return <aside className={classes.aside}>{renderSections}</aside>
}

const createStyles = (theme: Theme, isCabecalhoMinimizado: boolean, scrollY: number) => ({
  aside: {
    marginTop: '0.3rem',
    padding: `${isCabecalhoMinimizado ? '1rem' : '0'} 1.3rem 1rem 0`,
    borderRight: `1px solid ${theme.pallete.divider}`,
    position: isCabecalhoMinimizado ? 'fixed' : 'static',
    top: '7.5rem',
    height: `calc(100% - ${isCabecalhoMinimizado ? calcAsideHeightDiff(scrollY) + 'rem' : '0'})`,
    overflow: 'auto',
    background: theme.pallete.surface.main,
    width: isCabecalhoMinimizado && 'calc(100% / 12 * 3.2)',
    maxWidth: '28rem',
    [theme.breakpoints.down('lg')]: {
      width: isCabecalhoMinimizado && 'calc(100% / 12 * 2.75)',
    },
  } as CSSProperties,
})

function calcAsideHeightDiff(scrollY: number): number {
  const distBottom = window.document.body.offsetHeight - (scrollY + window.innerHeight)
  return Math.max(0, 6.1 - distBottom / 16) + 7.8
}
